export const RPC_CHAT_ENDPOINTS = {
    GET_MESSAGE_LIST: "/get_message_list_for_user",
    GET_MESSAGES: "/get_chat_message_by_id",
    GET_PRESIGNED_DOWNLOAD_URL: "/get_presigned_download_url",
    MARK_AS_READ: "/mark_message_as_read",
};
